'use client'

import { FC } from 'react'

import CaseStudyChallenge from '@/sections/CaseStudyChallenge'

const PayhawkChallenge: FC<{}> = () => {
    return (
        <CaseStudyChallenge
            paragraph={
                <>
                    Payhawk wanted to become a force for good. It was the right thing to do for our
                    planet, they were already pursuing B Corp status. But how could they make
                    climate change relevant to expense management?
                    <br />
                    <br />
                    Managing corporate spend, Payhawk found themselves poised to help solve one of
                    the biggest ESG headaches to date: scope 3 emission reporting. Scope 3 emissions
                    are indirect emissions in the value chain, including operational spending like
                    travel, transportation, and purchased goods. They’re a nightmare to track, but
                    measurable using spend-based emission calculations.
                    <br />
                    <br />
                    Payhawk found an ESG problem it could help solve. They asked their customers if
                    they wanted an emissions reporting feature within their spend management
                    platform, and 85% said yes. They had the spend data, they just needed a partner
                    who understood emission calculations.
                </>
            }
            imageSrc={'/images/payhawk-case-study/payhawk-problem.png'}
        />
    )
}

export default PayhawkChallenge
